/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { elementHasClassName, htmlspecialchars, str_trim } from './util.js';
import { setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { confirm_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';
import { closeAllTooltips } from './page-tooltips.js';

import { MPlugins } from './plugins.js';

import { convertToSelect2WithDefaultFit } from './select2.js';

import { MDMedia } from './media-data.js';
import { MDObject } from './object-data.js';

import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';

// import { MVSearch } from './search.js';

import { MVDownload } from './download.js';
import { MVExport } from './export.js';
import { MVPreview } from './preview.js';
import { MVPrint } from './print.js';
import { MVPublish } from './publish.js';
import { MVSend } from './send.js';

import { SelectionClassesObserver } from './media-items-selection-observer.js';


export let Lightbox = function($,mj) {

	let cfg_mr_top_c = '64px';
	const cfg_mr_top_o = '185px';

	let cfg_mri_top_c = '40px';
	const cfg_mri_top_o = '161px';

	var m_selection_changed = null;		// callback -> called whenever selection is changed ("ui-selected" flag)
	var m_select_elem = null;

	var cur_list_id = 0;
	var cur_item = {
		title: '',
		note: '',
		count: 0,
		owner_id: null,
		owner_display_name: null,
		x_name: null,
		x_id: null,
		x_plugin: null
	};
	var cur_item_locked = false;

	var m_lightbox_enabled = true;

	var mv_open = false;
	var mv_offset = 0;
	var mv_count_fit = 1;

	var m_tsv_ignore = false,
		gap_size = 9,
		itm_size = 80,
		itm_size_h = itm_size/2,
		tmb_size = itm_size-2,
		nav_itm_size = 13,
		m_single_lb = false,
		m_lb_node_droppable_hover_count = 0;

	var m_last_selected_other_lightbox_id = null;

	var m_dblclick_action = null;
	var m_mvdetail_open = null;

	var m_result_view_widget = null;

	var m_additional_related_elems = null;

	var m_changed_cbs = [];


	// eslint-disable-next-line no-unused-vars
	var m_sco = null;




	function droppable_out_fn( evt, ui ) {
		if( -- m_lb_node_droppable_hover_count <= 0 ) {
			$('.drop-info',ui.helper).empty();
			//$(ui.helper).css({width:'auto',height:'auto'});
			m_lb_node_droppable_hover_count = 0;
		}
	}

	function _append_buttons( node, deleted, download ) {
		var btns = [];
		if( !deleted ) {
			if( download ) btns.push('<div class="mmb mm-down keep" title="'+mjt('ctx-menu-download')+'"></div>');
			btns.push('<div class="mmb mm-open keep" title="'+mjt('ctx-menu-open')+'"></div>');
		}
		btns.push('<div class="mmb mm-lbout keep" title="'+mjt('ctx-menu-lb-out')+'"></div>');
		node.append( btns.join('') );
	}



	function initDisabled( result_view_widget, result_info_elem, additional_related_elems ) {
		m_lightbox_enabled = false;
		m_result_view_widget = result_view_widget;
		// .. before altering the DOM..
		initFromResultView(result_info_elem,additional_related_elems);
	}


	function init( lb_id_from_session, initially_opened, lb_id_from_request, selection_changed, single_lb, dblclick_action_fn, mvdetail_open_fn, result_view_widget, result_info_elem, additional_related_elems ) {
		m_selection_changed = selection_changed;
		m_single_lb = single_lb;
		m_select_elem = $('#lightbox-select');
		m_dblclick_action = dblclick_action_fn || function() { };
		m_mvdetail_open = mvdetail_open_fn || function() { };
		m_result_view_widget = result_view_widget;

		const $lb_result = $('#lb-result');
		m_sco = new SelectionClassesObserver($lb_result[0],false);

		MPlugins.iterateByType( 'MediaThumbnailView', function(name,plugin) {
			plugin.initViewNodesRoot( 'lightbox', $('#lb-result'), function(e,action) {
				if( action==='annotations' ) {
					var lb_item = $(e.target).closest('.lb-item');
					var media_id = lb_item.attr('data-mj_mid');
					if( media_id ) m_mvdetail_open( [media_id], 'annotations', 0, cur_item.count>1 ? openWholeResultInDetailView : null );
				}
			} );
			plugin.bindStatusChanged( 'lightbox', function( media_ids, meta ) {
				_withNodesByMediaIds(media_ids,function(media_id,node) {
					setItemMetadata(node,media_id,meta[media_id]||{'-1':[0]});
				} );
			} );
		} );

		MDMedia.bindMetaChanged( function lightbox_on_meta_changed( media_ids, meta, trigger_meta_ids ) {
			// start requests for further view status infos through plugins
			MPlugins.callOnAllPluginsOfType('MediaThumbnailView','queryMediaViewStatus',true,'lightbox',media_ids,meta,false);
			_withNodesByMediaIds(media_ids,function(media_id,node) {
				setItemMetadata(node,media_id,meta[media_id]||{'-1':[0]});
			} );
		} );

		MDMedia.bindMediaDeleted( function lightbox_on_media_deleted( media_ids ) {
			updateSmallView(false,false);
		} );
		MDMedia.bindMediaRestored( function lightbox_on_media_restored( media_ids, data ) {
			// console.log({w:'LIGHTBOX bindMediaRestored',media_ids,data});
			updateSmallView(false,false);
		} );

		$(document).on( 'mjsrecreatethumbnails', function( e, media_id, meta ) {
			_withNodeByMediaId(media_id,function(media_id,node) {
				const deleted = !node.hasClass('undel');
				const download = $.data(node[0],'r_dwn');
				MThumbnails.createOnTarget(
					node[0],
					{
						media_id: media_id,
						width: tmb_size,
						height: tmb_size,
						meta: meta,
						thumb_loader_anim: true,
					}
				);
				node.attr( 'title', media_id+': '+(meta[101]?meta[101][0]:'') );
				_append_buttons(node,deleted,download);
			});
		} );

		$(document).on( 'mjswinresize.MVLightbox', $.debounce( 250, function(e) {
			// NOTE: this will change the current selection!
			// (will unselect all media, that were selected in lightbox...)
			updateSmallView(false,false);
		} ) );


		// .. before altering the DOM..
		initFromResultView(result_info_elem,additional_related_elems);


		$('#lightbox-toggle,#media-header-lightbox-title').closest('td').addClass('link').click( function(e) {
			toggleSmallView();
			e.preventDefault();
		} );

		$('#lb-go-i,#lb-go-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) {
				go( function() {
					if( mv_open ) toggleSmallView(e,null,false);//,false);
				} );
			}
			e.preventDefault();
		} );

		$('#lb-open-i,#lb-open-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) open(0);
			e.preventDefault();
		} );
		$('#lb-download-i,#lb-download-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) download();
			e.preventDefault();
		} );
		$('#lb-send-i,#lb-send-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) send();
			e.preventDefault();
		} );
		$('#lb-publish-i,#lb-publish-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) publish();
			e.preventDefault();
		} );
		$('#lb-export-i,#lb-export-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) do_export();
			e.preventDefault();
		} );
		$('#lb-print-i,#lb-print-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) print();
			e.preventDefault();
		} );
		$('#lb-edit-i,#lb-edit-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) edit();
			e.preventDefault();
		} );
		$('#lb-delete-i,#lb-delete-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) del();
			e.preventDefault();
		} );
		$('#lb-note-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) note();
			e.preventDefault();
		} );
		$('#lb-share-t').click( function(e) {
			if( !$(this).hasClass('disabled') ) share();
			e.preventDefault();
		} );
		$('#lb-less')
			.click( function(e) {
				less();
				e.preventDefault();
			} )
			.droppable( {
				accept: '.drag-media',
				addClasses: false,
				tolerance: 'pointer',
				over: function( evt, ui ) {
					droppable_out_fn(evt,ui);
					less();
				},
			} );
		$('#lb-more')
			.click( function(e) {
				more();
				e.preventDefault();
			} )
			.droppable( {
				accept: '.drag-media',
				addClasses: false,
				tolerance: 'pointer',
				over: function( e, ui ) {
					droppable_out_fn(e,ui);
					more();
				},
			} );

		// let set_initial_lb_id = undefined;
		// if( isValidLightboxId(lb_id_from_request) ) set_initial_lb_id = lb_id_from_request;
		// else if( isValidLightboxId(lb_id_from_session) ) set_initial_lb_id = lb_id_from_session;
		// createSelect(false,true,set_initial_lb_id);

		createSelect(false,true);

		if( isValidLightboxId(lb_id_from_request) ) {
			// a lightbox id was set in request url (=show lightbox and display a hint to the user)
			if( $('#media-result').hasClass('no-search') ) $('#mr-no-search').addClass('mr-check-lightbox');

			initSmallView(true);
			// initSmallView(false);

			change(lb_id_from_request,true,true,function() {
				setTimeout( function() {
					// a lightbox id was set in request url (=show lightbox and display a hint to the user)
					if( $('#media-result').hasClass('no-search') ) $('#mr-no-search').addClass('mr-check-lightbox');
				}, 50 );
			},null,true,true);

			if( !initially_opened ) setInSession('lightbox_small_opened','1');
		} else {
			// initial lightbox state
			initSmallView(!!initially_opened);
			var new_lb_id = isValidLightboxId(lb_id_from_session) ? lb_id_from_session : parseInt(m_select_elem.val(),10);
			change(new_lb_id,true,false,null,null,true);
		}


		if( m_single_lb ) {
			// remove "add new lightbox" function
			m_select_elem.find('[value=0]').remove();
			// disable "delete" function
			$('#lb-delete-i,#lb-delete-t').addClass('disabled');
		}
		// setup drop area
		$('#media-header-lightbox-1').droppable( {
			accept: '.drag-media',
			addClasses: false,
			tolerance: 'pointer',
			over: function( e, ui ) {
				if( !mv_open ) {
					droppable_out_fn(e,ui);
					toggleSmallView(e);
				}
			},
		} );
		// setup click handlers for items in #lb-result
		$lb_result
			.on( 'click', '.lb-item', function(evt) {
				var i, j;
				// remove focus from search string (for kbd nav...)
				$('#search-string').blur();
				var self = $(this);
				if( !self.hasClass('undel') ) {
					self.removeClass('ui-selected');
				} else {
					// unselect all category items
					$('#media-result .cthumbnail').removeClass('ui-selected');
					if( evt.shiftKey ) {
						// search backwards...
						var idx = parseInt(self.attr('mj_tidx'),10);
						var nodes = $lb_result.children('.lb-item');
						var found = false;
						for( i=idx-1; i>=0; i-- ) {
							if( elementHasClassName(nodes[i],'ui-selected') ) {
								for( j=i+1; j<=idx; j++ ) $(nodes[j]).addClass('ui-selected');
								found = true;
								break;
							}
						}
						if( !found ) {
							// search forward...
							for( i=idx+1; i<nodes.length; i++ ) {
								if( elementHasClassName(nodes[i],'ui-selected') ) {
									for( j=idx; j<i; j++ ) $(nodes[j]).addClass('ui-selected');
									break;
								}
							}
						}
					} else if( evt.ctrlKey || evt.altKey ) {
						// console.log({w:'Lightbox... click .lb-item + ( evt.ctrlKey || evt.altKey )', hasClassUiSelected:self.hasClass('ui-selected') });
						self.toggleClass('ui-selected');
					} else {
						// plain click on any other media node -> select node
						$('#media-result .thumbnail').removeClass('ui-selected');
						if( !self.hasClass('ui-selected') ) $lb_result.children('.lb-item').removeClass('ui-selected');
						self.addClass('ui-selected');
					}
					selectionChanged(evt,'click .lb-item');
				}
			} )
			.on( 'dblclick', '.lb-item', function(evt) {
				var self = $(this);
				if( self.hasClass('undel') ) {
					// select the node
					$('#media-result .thumbnail,#media-result .cthumbnail').removeClass('ui-selected');
					$lb_result.children('.lb-item').removeClass('ui-selected');
					self.addClass('ui-selected');
					selectionChanged(evt,'dblclick .lb-item');
					m_dblclick_action();
				}
			} )
			.on( 'click', '.mm-lbout', function(e) {
				e.preventDefault();
				e.stopPropagation();
				Lightbox.remove( [ $(this).parent().attr('data-mj_mid') ], function() {
					// TODO: do select prev/next node ???
				} );
			} )
			.on( 'click', '.mm-open',  function(e) {
				// e.preventDefault();
				// e.stopPropagation();
				m_mvdetail_open( [$(this).parent().attr('data-mj_mid')], 'detail', 0, cur_item.count>1 ? openWholeResultInDetailView : null );
			} )
			.on( 'click', '.mm-down',  function(e) {
				e.preventDefault();
				e.stopPropagation();
				MVDownload.open( [ $(this).parent().attr('data-mj_mid') ] );
			} );

	} // init()


	function initFromResultView( result_info_elem, additional_related_elems ) {
		// var $mr = m_result_view_widget && m_result_view_widget.element ? m_result_view_widget.element : $('#media-result');
		// cfg_mr_top_c = getComputedStyle($mr[0]).top;

		var $mri = result_info_elem && result_info_elem.length ? result_info_elem : $('#media-result-info');
		// cfg_mri_top_c = getComputedStyle($mri[0]).top;

		// m_additional_related_elems = $('#media-preview,#media-preview-band').add($mri);
		m_additional_related_elems = additional_related_elems.add($mri);
	}

	function initSmallView( opened ) {
		// console.trace({fn:'initSmallView',opened,mv_open});
		mv_open = !!opened;
		$('#lightbox-toggle').toggleClass('close',mv_open).attr('title',mv_open?mjt('lb-close'):mjt('lb-open'));
		$('#media-header-lightbox-title').attr('title',mv_open?mjt('lb-close'):mjt('lb-open'));

		m_additional_related_elems.css( 'top', mv_open ? cfg_mri_top_o : cfg_mri_top_c );

		if( mv_open ) {
			const mr = m_result_view_widget.element;
			mr.css( 'top', mv_open ? cfg_mr_top_o : cfg_mr_top_c );
		}

		const mls = $('#media-lightbox-small');
		mls.css( 'display', mv_open ? 'block' : 'none' );

		updateSmallView(false,false);
	}


	function toggleSmallView( initiating_event, done_cb, force_open_close ) {
		if( m_tsv_ignore ) return false; // toggle in progress
		m_tsv_ignore = true;

		const mr = m_result_view_widget.element;

		let tmp_reset_offset = false;

		if( force_open_close===false ) {
			mv_open = false;
			mr.css('top',cfg_mr_top_o);
		} else if( force_open_close===true ) {
			mv_open = true;
			tmp_reset_offset = true;
			mr.css('top',cfg_mr_top_c);
		} else {
			mv_open = mr.css('top')==cfg_mr_top_c;
		}

		$('#lightbox-toggle').toggleClass('close',mv_open).attr('title',mv_open?mjt('lb-close'):mjt('lb-open'));
		$('#media-header-lightbox-title').attr('title',mv_open?mjt('lb-close'):mjt('lb-open'));

		const mls = $('#media-lightbox-small');

		if( mv_open ) {
			const mri_css = { top:cfg_mri_top_o };
			const mr_css = { top:cfg_mr_top_o };
			m_additional_related_elems.animate( mri_css, 100 );
			mr.animate( mr_css, 100 );
		} else {
			const mri_css = { top:cfg_mri_top_c };
			const mr_css = { top:cfg_mr_top_c };
			m_additional_related_elems.animate( mri_css, 100 );
			mr.animate( mr_css, 100 );
			$('#lb-less').css('display','none').siblings('.lb-item').remove();
			$('#lb-more').css('display','none');
			if( cur_item.x_plugin ) cur_item.x_plugin.beforeUpdateSmallView(mv_open,mls);
		}

		//.slideToggle
		mls[mv_open?'slideDown':'slideUp']( 100, function() {
			if( mv_open ) {
				$('#media-header-lightbox-1').removeClass('drop-active');
				updateSmallView(tmp_reset_offset,false,initiating_event,done_cb);
			} else {
				mls.css( 'display', 'none' );
				selectionChanged(null,'toggleSmallView -> slideUp');
				if( done_cb ) done_cb();
			}
			m_tsv_ignore=false;
			setInSession('lightbox_small_opened',mv_open?'1':'0');
			MVPreview.onResize(false,true);
		} );
	}


	function updateSmallView( reset_offset, goto_last_page, initiating_event, done_cb ) {
		if( reset_offset ) mv_offset = 0;

		if( cur_item.x_plugin ) cur_item.x_plugin.beforeUpdateSmallView(mv_open,$('#media-lightbox-small'));

		if( !mv_open ) return; // nothing to do
		if( !cur_list_id ) return; // should not really happen

		// build info string
		var info_html = '<b>'+cur_item.count.toString()+'</b> ';
		info_html += ( cur_item.count==1 ? mjt('lb-info-file') : mjt('lb-info-files')  );
		info_html += ' <b>'+htmlspecialchars(cur_item.title)+'</b>';
		$('#lb-info').html(info_html);
		var note = cur_item.note;
		if( cur_item.note.length > 10 ) note = cur_item.note.substring(0, 10) + '...';
		$('#lb-note-t').html( (note.length == 0) ? mjt('lb-note-2') : '<i>' + htmlspecialchars(note,false,true) + '</i>' );
		// available width & add thumbnails

		var mlsi_offset = 10;
		var mlsi_width = $('#media-lightbox-small-inner').innerWidth();
		var lb_less = $('#lb-less');
		var lb_more = $('#lb-more');

		// drop target tweaking...

		if( cur_item.count==0 ) {

			lb_less.css('display','none').siblings('.lb-item,.lb-drop-target').remove();
			lb_more.css('display','none');
			// setup drop target
			var drop_trg_w = mlsi_width + 2 * ( nav_itm_size - mlsi_offset - gap_size );
			$('#lb-less')
				.after( '<div class="lb-drop-target" style="left:'+(nav_itm_size+gap_size)+'px; width:'+drop_trg_w+'px" mj_pos="0"></div>' )
				.siblings('.lb-drop-target').droppable( {
					accept: '.drag-media',
					addClasses: false,
					tolerance: 'pointer',
					hoverClass: 'drop-hover',
					drop: function( evt, ui ) {
						var media_ids = $(ui.draggable).data('drag_media_ids');
						insert( media_ids );
					},
					over: function( evt, ui ) {
						$('.drop-info',ui.helper).text(mjt('media-drop-on-lightbox-add-only','!'));
						m_lb_node_droppable_hover_count ++;
					},
					out: droppable_out_fn,
				} )
			;
			// refresh drop targets positions
			if( $.ui.ddmanager && $.ui.ddmanager.current ) $.ui.ddmanager.prepareOffsets( $.ui.ddmanager.current, initiating_event );
			// call done_cb - call delayed for consistency
			if( done_cb ) window.setImmediate( done_cb );

		} else {
			mv_count_fit = Math.floor( (mlsi_width-mlsi_offset-2*nav_itm_size) / (itm_size+gap_size) );
			if( mv_count_fit < 1 ) mv_count_fit = 1; // min 1
			if( goto_last_page ) mv_offset = mv_count_fit * Math.floor( cur_item.count / mv_count_fit );
			if( mv_offset == cur_item.count ) mv_offset -= mv_count_fit;
			if( mv_offset < 0 ) mv_offset = 0;
			var has_less = mv_offset>0;
			var has_more = mv_offset+mv_count_fit < cur_item.count;

			MDObject.queryObjectItems('lightbox',null,cur_list_id,mv_offset,mv_count_fit,mj.required_thumbnail_meta_ids,function(j) {

				if( !j ) return;

				// NOTE: j.media_ids MAY NOT ALWAYS BE an array,
				//       if it is an object, then its keys are the 'absolute' positions in result list!
				var media_ids_arr = Object.keys(j.media_ids).map( function(k) {
					return j.media_ids[k];
				} );

				// start requests for further view status infos through plugins
				MPlugins.callOnAllPluginsOfType('MediaThumbnailView','queryMediaViewStatus',true,'lightbox',media_ids_arr,j.meta,false);


				lb_less
					.css('display',has_less?'block':'none')
					.siblings('.lb-item,.lb-drop-target').remove().end();
				var $after_elem = lb_less;


				var dtrgs_html = [];

				var first = true;
				var list_pos = 0;
				var leftpx = mlsi_offset + gap_size + nav_itm_size;

				for( var idx=0; idx<media_ids_arr.length; idx++ ) {
					var media_id = media_ids_arr[idx];
					list_pos = parseInt(idx,10)+1;

					var xclass = media_id && j.meta[media_id] && j.meta[media_id][-1] ? 'undel' : 'deleted';
					var $item = $('<div class="smn lb-item '+xclass+'" style="left:'+leftpx+'px" data-mj_mid="'+media_id+'" mj_tidx="'+idx+'"></div>')
						.insertAfter($after_elem);

					var item_elem = $item[0];
					var meta = j.meta[media_id] || { '-1':[0] };
					var deleted = xclass==='deleted';
					var download = j.r_download && j.r_download[media_id]!=undefined && j.r_download[media_id];
					$.data(
						item_elem,
						{
							media_id: media_id,
							r_dwn: download,
							r_edt: j.r_edit && j.r_edit[media_id]!=undefined && j.r_edit[media_id],
							r_del: j.r_delete && j.r_delete[media_id]!=undefined && j.r_delete[media_id],
						}
					);

					MThumbnails.createOnTarget(
						item_elem,
						{
							media_id: media_id,
							width: tmb_size,
							height: tmb_size,
							meta: meta,
							thumb_loader_anim: true,
						}
					);

					_append_buttons($item,deleted,download);
					setItemMetadata($item,media_id,meta);

					$after_elem = $item;


					var dclass = first ? '' : ' lb-drop-target-mid';
					var drop_leftpx = leftpx - gap_size - ( first ? 0 : itm_size_h );
					dtrgs_html.push( '<div class="lb-drop-target'+dclass+'" style="left:'+drop_leftpx+'px" mj_pos="'+list_pos+'"></div>' );

					leftpx += itm_size + gap_size;
					first = false;
				}

				var drop_trg_w = Math.max( has_more ? gap_size + itm_size_h : mlsi_width - 25 - leftpx + itm_size_h, gap_size );
				dtrgs_html.push( '<div class="lb-drop-target lb-drop-target-right" style="left:'+(leftpx-gap_size-itm_size_h)+'px; width:'+drop_trg_w+'px" mj_pos="'+(list_pos+1)+'"></div>' );

				lb_less
					.after(dtrgs_html.join(''))
					.siblings('.lb-drop-target').droppable( {
						// drop on lb-drop-target...
						accept: '.drag-media',
						addClasses: false,
						tolerance: 'pointer',
						hoverClass: 'drop-hover',
						drop: function( evt, ui ) {
							var media_ids = $(ui.draggable).data('drag_media_ids');
							var pos = $(this).attr('mj_pos');
							// insert media_ids at pos=mj_tidx -> but ignore errors (means: don't show an error when list counts don't change, as in a pure 'move in list')
							insert( media_ids, pos, true );
						},
						over: function( evt, ui ) {
							$('.drop-info',ui.helper).text(mjt('media-drop-on-lightbox','!'));
							m_lb_node_droppable_hover_count ++;
						},
						out: droppable_out_fn,
					} );

				lb_more.css( {
					display: has_more ? 'block' : 'none',
					left: leftpx.toString()+'px',
				} );

				setTitleCountNote(null,j.result_count,null,true);
				selectionChanged(null,'updateSmallView -> MDObject.queryObjectItems..');
				// refresh drop targets positions
				if( $.ui.ddmanager && $.ui.ddmanager.current ) $.ui.ddmanager.prepareOffsets( $.ui.ddmanager.current, initiating_event );
				// call done_cb
				if( done_cb ) done_cb();
			} );
		}

	}

	function setItemMetadata( node, media_id, meta ) {
		node.attr( 'title', media_id+': '+(meta[101]?meta[101][0]:'') );
		// update further view status through plugins
		MPlugins.callOnAllPluginsOfType('MediaThumbnailView','updateViewNode',true,'lightbox',node,media_id,meta);
	}

	function getOptionLabel( data ) {
		var title = data.title;
		var count = data.count;
		//var note = data.note;
		var label = count==1 ? mjt('lb-select-list-1') : mjt('lb-select-list-x');
		var result_label = label.replace('%1',title).replace('%2',count);

		// add sharing info (but skip it, if plugin attached)
		var with_sharing_info = data.x_name===null || data.x_name==='';
		if( with_sharing_info ) {
			var owner_id = data.owner_id;
			if( owner_id!=mj.user_id ) {
				var sharing_info = mjt('lb-select-list-shared-info').replace('%1',data.owner_display_name||owner_id);
				result_label += ' ' + sharing_info;
			}
		}
		return result_label;
	}


	function setTitleCountNote( title, count, note, update_select_elem ) {
		var prev_item = Object.assign({},cur_item);

		if( typeof title === 'undefined' ) title = null;
		if( typeof count === 'undefined' ) count = null;
		if( typeof note === 'undefined' ) note = null;
		if( title!==null ) cur_item.title = title;
		if( count!==null ) cur_item.count = parseInt(count,10);
		if( note!==null ) cur_item.note = note;

		if( update_select_elem && m_select_elem ) {
			m_select_elem
				.find(':selected')
				.data('count',cur_item.count)
				.data('note',cur_item.note)
				.data('title',cur_item.title)
				.attr('title',cur_item.note)
				.text( getOptionLabel(cur_item) );
			if( cur_item.title!==prev_item.title || cur_item.count!==prev_item.count || cur_item.note!==prev_item.note ) {
				// select2() widget must be recreated, because it does not correctly track change on options :(
				createSelect(true,false);
			}
		}

		updateActionViewStates();
	}


	function updateActionViewStates() {
		// re-enable eventually disabled actions
		$('#lb-go-i,#lb-go-t,#lb-note-t,#lb-note-i,#lb-edit-t,#lb-edit-i,#lb-delete-t,#lb-delete-i').removeClass('disabled');

		// set toolbar states
		$('#lb-open-i,#lb-open-t,#lb-publish-i,#lb-publish-t,#lb-export-i,#lb-export-t,#lb-print-i,#lb-print-t').toggleClass('disabled',cur_item.count===0);

		// assume downloads are always possible... (final check is in download dialog anyway)
		var download_possible = true;
		$('#lb-download-i,#lb-download-t').toggleClass('disabled',cur_item.count===0||!download_possible);

		// "send" depends on state of all lists...
		var all_lists = getLists();
		var count_all = 0;
		for( var i=0; i<all_lists.length; ++i ) count_all += all_lists[i].count;
		$('#lb-send-i,#lb-send-t').toggleClass('disabled',count_all===0);

		if( cur_item_locked ) {
			$('#lb-note-t,#lb-edit-t,#lb-delete-t,#lb-note-i,#lb-edit-i,#lb-delete-i').addClass('disabled');
		}

		// further actions become disabled when plugin attached ..
		if( cur_item.x_plugin!=null ) {
			cur_item.x_plugin.toggleLightboxActions();
		}

		updateItemsButtonsViewState();

		if( m_result_view_widget ) {
			m_result_view_widget.setLightboxEditable( !cur_item_locked );
		}
	}

	function updateItemsButtonsViewState() {
		$('#media-lightbox-small-inner .mm-lbout').toggleClass('disabled',cur_item_locked);
	}


	function setLocked( locked ) {
		cur_item_locked = !!locked;
		updateActionViewStates();
	}

	function isLocked() {
		return cur_item_locked;
	}


	function change( list_id, set_select_value, save, done_cb, err_cb, initial, list_id_explicitely_requested, do_not_load_into_result_view ) {
		if( !isValidLightboxId(list_id) ) {
			if( err_cb ) err_cb();
			return;
		}

		if( cur_item.x_plugin ) {
			cur_item.x_plugin.beforeDetachFromLightbox();
		}

		// set cur_item
		cur_list_id = list_id;
		cur_item = Object.assign(
			{},
			{
				title: '',
				note: '',
				count: 0,
				owner_id: null,
				x_name: null,
				x_id: null,
				x_plugin: null
			}
		);
		cur_item_locked = false;

		// select the given lightbox..
		if( set_select_value ) {
			m_select_elem.val(list_id).trigger('change.select2');
			updateRenderedSelection();
		}

		// get count & title from selected option
		var o = m_select_elem.find(':selected');
		var od = o.data();
		setTitleCountNote( od.title, od.count, od.note, false );

		cur_item.owner_id = od.owner_id;
		cur_item.x_name = od.x_name;
		cur_item.x_id = od.x_id;

		var change_continued = function( force_open_close_small_view ) {

			// reset css classes of #media-header-lightbox (plugins may add arbitrary classes)
			var mhl_elem = $('#media-header-lightbox');
			mhl_elem[0].className = '';
			if( cur_item.x_plugin ) {
				cur_item.x_plugin.afterAttachToLightbox(mhl_elem);
			}
			triggerLightboxChanged(cur_list_id,cur_item);

			// reset css classes of #media-lightbox-small (plugins may add arbitrary classes)
			var mls_elem = $('#media-lightbox-small');
			var mls_elem_cn = mls_elem.hasClass('ui-selectable') ? 'ui-selectable' : '';
			mls_elem[0].className = mls_elem_cn;

			var skip_small_view = m_result_view_widget.getWrappedListType()==='lightbox';
			var close_small_view = false;

			if( cur_item.x_plugin ) {
				[skip_small_view,close_small_view] = cur_item.x_plugin.getViewOptions(initial,list_id_explicitely_requested);
			} else if( initial ) {
				[skip_small_view,close_small_view] = [false,false];
			}

			// update views..
			if( skip_small_view && !do_not_load_into_result_view ) {
				// load into result view ..
				go( function() {
					// and into small-view ..
					if( ( force_open_close_small_view===true || force_open_close_small_view===false ) && (force_open_close_small_view!==mv_open) ) {
						toggleSmallView(null,done_cb,force_open_close_small_view);
					} else if( close_small_view ) {
						toggleSmallView(null,done_cb,false);
					} else {
						updateSmallView(true,false,null,done_cb);
					}
				} );
			} else {
				// load into small-view only ..
				if( ( force_open_close_small_view===true || force_open_close_small_view===false ) && (force_open_close_small_view!==mv_open) ) {
					toggleSmallView(null,done_cb,force_open_close_small_view);
				} else if( close_small_view ) {
					toggleSmallView(null,done_cb,false);
				} else {
					updateSmallView(true,false,null,done_cb);
				}
			}

			if( save ) setInSession('lightbox_id',list_id);
		};

		// get item-plugin for all hooks related to currently selected item=lightbox
		var x_item = getLightboxObject(list_id);
		if( x_item!==null && x_item.x_name ) {
			var useItemPlugin = false;
			MPlugins.iterateByType( 'MediaLightboxView', function(name,plugin) {
				if( !plugin.createItemPlugin ) return;
				useItemPlugin = plugin.createItemPlugin( x_item.x_name, x_item.x_id, x_item, function _on_item_plugin_created() {
					// "this" is a plugin instance object provided by plugin.createItemPlugin()
					cur_item.x_name = x_item.x_name;
					cur_item.x_id = x_item.x_id;
					cur_item.x_plugin = this;
					// change_continued(false);
					// change_continued(list_id_explicitely_requested?true:undefined);
					change_continued(list_id_explicitely_requested?true:false);
				} );
				if( useItemPlugin ) return false; // early exit MPlugins.iterateByType
			} );
			if( !useItemPlugin ) {
				// change_continued(true);
				change_continued(undefined);
			}
		} else {
			// change_continued(true);
			change_continued(initial?(list_id_explicitely_requested?true:undefined):true);
		}
	}

	function create() {
		if( m_single_lb ) return;
		MTemplates.queryDialogHTML( 'form_lightbox_edit', function() {
			// create a new lightbox..
			var lb_create_title = $('#lb-create-title');
			lb_create_title.val( mjt('lb-default-name')+' ' );
			$('#lb-create-dialog')
				.dialog('destroy')
				.dialog( {
					width:262,
					height:150,
					modal:true,
					resizable:false,
					close:function(ev, ui) {
						$(this).dialog('destroy');
					},
					open:function(ev, ui) {
						window.setTimeout( function() {
							lb_create_title.select();
							// // restore list_id in m_select_elem
							// if( cur_list_id!=0 ) {
							// 	// change(cur_list_id,true,false);
							// 	change(cur_list_id,true,false,null,null,false,false,true);
							// }
						}, 12 );
					},
				} )
				.show()
				.find('form')
				.off().submit( function( e ) {
					var title = str_trim( lb_create_title.val() );
					var object_attributes = { 'title':title, 'note':'' };
					MDObject.createObject('lightbox',object_attributes,null,false,function(j) {
						renderSelect(j.lists,j.object_id);
						change(j.object_id,true,true);
						$('#lb-create-dialog').dialog('destroy');
						if( !mv_open ) toggleSmallView(e,null,true);
					} );
					return false;
				} )
				.end();
		} );
	}

	function updateRenderedSelection() {
		var select_elem0 = m_select_elem[0];
		var option = select_elem0.options[select_elem0.selectedIndex];
		if( option ) {
			const data = $(option).data() || {};
			if( data && data.x_name ) {
				var $s2rendered = m_select_elem.next('.select2-container').find('.select2-selection__rendered');

				// var handledByPlugin = false;
				MPlugins.iterateByType('MediaLightboxView',function(name,plugin) {
					if( !plugin.updateSelect2RenderedSelectionFromOptionElem ) return;
					if( plugin.updateSelect2RenderedSelectionFromOptionElem($s2rendered,option,data) ) {
						// handledByPlugin = true;
						// early exit MPlugins.iterateByType
						return false;
					}
				} );
				// if( !handledByPlugin ) {
				// 		TODO
				// }
			}
		}
	}

	function onSelectChange( e ) {
		// console.trace({fn:'onSelectChange',e});

		var select_elem0 = m_select_elem[0];
		var option = select_elem0.options[select_elem0.selectedIndex];
		var list_id = option.value;
		if( list_id==0 ) {
			create();
			return;
		}

		updateRenderedSelection();

		change( list_id, false, true, function() {
			if( m_result_view_widget.getWrappedListType()==='lightbox' ) {
				// result_view is showing contents of a lightbox ...
				// -> change() has already switched result_view to show contents of <list_id>
				m_result_view_widget.listChanged();
			} else if( !mv_open ) {
				toggleSmallView();
			}
		} );
	}


	function createSelect( recreate, rerender, set2value ) {
		if( recreate ) {
			m_select_elem.select2('destroy');
		}

		if( rerender ) reRenderSelect(set2value);

		convertToSelect2WithDefaultFit(
			m_select_elem,
			false,
			{
				containerCssClass: 'lightbox',
				dropdownParent: $('#page'),
				//dropdownAutoWidth: true,
				width: 'element', // -> the default 'resolve' would try 'style' first, then fail and use 'element' anyway

				templateResult: function( item, li ) {
					if( item && item.element && item.element.style.cssText.length ) li.style.cssText = item.element.style.cssText;
					if( item.loading ) return item.text;
					var term = window._mj_cur_select2_query.term || '';
					var spanClassName = item.class || '';

					// // store item as "data-item" on <li> element
					// li.dataset.item = item.element && item.element.dataset && item.element.dataset.item ? item.element.dataset.item : null;

					// console.log({ fn:'Lightbox.createSelect -> templateResult', item, li, term, spanClassName, data:$.data(item.element) });

					if( item && item.element ) {
						const data = $(item.element).data() || {};
						//console.log({ fn:'Lightbox.createSelect -> templateResult', item, li, term, spanClassName, data });
						if( data && data.x_name ) {
							//console.log({ item, li, data });
							var pluginResult = null;
							MPlugins.iterateByType('MediaLightboxView',function(name,plugin) {
								if( !plugin.getSelect2TemplateResultFromOptionElem ) return;
								pluginResult = plugin.getSelect2TemplateResultFromOptionElem(item,term,li,data);
								if( pluginResult!==null ) return false; // early exit MPlugins.iterateByType
							} );
							if( pluginResult!==null ) return pluginResult;
						}
					}
					return window._mj_select2_markMatch(item.text,term,spanClassName);
				}
			}
		);

		m_select_elem
			.off('.MVLightbox')
			.on('select2:close',function(e) {
				closeAllTooltips();
			})
			.on('change.MVLightbox',onSelectChange);
	}


	function renderSelect( lists, set2val ) {
		var grouped_lists = {
			std: []
		};
		var use_optgroups = false;
		for( let i=0; i<lists.length; ++i ) {
			let li = lists[i];
			if( li.x_name ) {
				use_optgroups = true;
				if( grouped_lists.hasOwnProperty(li.x_name) ) grouped_lists[li.x_name].push(li);
				else grouped_lists[li.x_name] = [ li ];
			} else {
				grouped_lists.std.push(li);
			}
		}

		// move "std" group (plain  lightboxes) to bottom
		var tmp_std = grouped_lists.std;
		delete grouped_lists.std;
		grouped_lists.std = tmp_std;
		//console.log({ grouped_lists });

		let select_html_arr = [];
		for( var group_type in grouped_lists ) {
			if( !grouped_lists.hasOwnProperty(group_type) ) continue;

			var html = '';
			var lists_in_group = grouped_lists[group_type];
			for( let i=0; i<lists_in_group.length; ++i ) {
				let li = lists_in_group[i];
				const note_escaped = htmlspecialchars(li.note,true,true);
				const title_escaped = htmlspecialchars(li.title,true,true);
				const li_count = li.count;
				html +=
					'<option value="'+li.list_id+'" '
						+'title="'+note_escaped+'" '
						+'data-count="'+li_count+'" '
						+'data-note="'+note_escaped+'" '
						+'data-title="'+title_escaped+'" '
						+'data-owner_id="'+li.owner_id+'" '
						+'data-owner_display_name="'+li.owner_display_name+'" '
						+'data-x_name="'+htmlspecialchars(li.x_name||'',true,true)+'" '
						+'data-x_id="'+htmlspecialchars(li.x_id||'',true,true)
						+( set2val!==undefined && set2val===li.list_id ? ' selected' : '' )
						+'">'
						+htmlspecialchars(getOptionLabel(li))
					+'</option>';
			}
			if( use_optgroups ) {
				var group_label;
				if( group_type==='std' ) {
					group_label = mjt('lb-group-label-std');
				} else {
					// query appropriate label on plugin(s)
					var resultObj = {};
					MPlugins.callOnAllPluginsOfType('MediaLightboxView','getOptGroupLabel',false,group_type,resultObj);
					group_label = resultObj.group_label;
				}
				html = '<optgroup label="'+htmlspecialchars(group_label,true,true)+'">' + html + '</optgroup>';
			}
			select_html_arr.push(html);
		}

		if( !m_single_lb ) {
			var last = '<option value="0">'+mjt('lb-add')+'</option>';
			if( use_optgroups ) last = '<optgroup label="'+mjt('lb-group-label-add')+'">'+last+'</optgroup>';
			select_html_arr.push(last);
		}
		m_select_elem
			.html( select_html_arr.join('') )
			.toggleClass('has-optgroups',use_optgroups);
	}

	function reRenderSelect( set2val ) {
		var lists = getLists();
		renderSelect(lists,set2val);
	}

	function update( ondone ) {
		MDObject.queryObjectList('lightbox','shared','',function( lists ) {
			//console.log({ fn:'Lightbox.update', lists });
			for( let i=0; i<lists.length; ++i ) {
				let li = lists[i];
				if( li.owner_data ) {
					li.owner_display_name = li.owner_data['display-name'] || li.owner_id;
				}
			}
			renderSelect(lists);
			if( ondone ) ondone();
		} );
	}


	function getLists() {
		let lists = [];
		m_select_elem.find('option').each( function() {
			const list_id = parseInt(this.value,10);
			if( list_id > 0 ) {
				const sd = $(this).data();
				lists.push( {
					list_id: list_id,
					title: sd.title || '',
					count: sd.count || 0,
					note: sd.note || '',
					owner_id: sd.owner_id || '',
					owner_display_name: sd.owner_display_name || '',
					x_name: sd.x_name || '',
					x_id: sd.x_id || ''
				} );
			}
		} );
		return lists;
	}

	function getLightboxObject( object_id ) {
		let item = null;
		m_select_elem.find('option').each( function() {
			const list_id = parseInt(this.value,10);
			if( list_id>0 && list_id==object_id ) {
				const sd = $(this).data();
				item = {
					list_id: list_id,
					title: sd.title || '',
					count: sd.count || 0,
					note: sd.note || '',
					owner_id: sd.owner_id || '',
					owner_display_name: sd.owner_display_name || '',
					x_name: sd.x_name || '',
					x_id: sd.x_id || ''
				};
				return false; // break out of $.each()
			}
		} );
		return item;
	}

	function actionOnWholeResult( callback ) {
		if( cur_item.count!=0 ) {
			MDObject.queryObjectMediaIDs('lightbox',null,cur_list_id,function(media_ids,result_count) {
				setTitleCountNote( null, result_count, null, true );
				if( media_ids.length ) callback(media_ids,result_count);
			} );
		}
	}

	function openWholeResultInDetailView( done_cb, mode ) {
		// open all media in lb in CURRENT mode, switching to previously shown media_id
		actionOnWholeResult( function(media_ids) {
			m_mvdetail_open( media_ids, mode||null, -1, null, function() {
				if( done_cb ) done_cb();
			} );
		} );
	}

	function isValidLightboxId( list_id ) {
		return list_id > 0 && m_select_elem.find('[value='+list_id+']').length > 0;
	}


	function go( done_cb ) {
		// load lightbox object into result view ...
		m_result_view_widget.loadObject('lightbox',cur_list_id,cur_item,false,function() {
			if( done_cb ) done_cb();
		});
	}

	function open( idx, done_cb ) {
		// open all items of lb in DETAIL mode ...
		actionOnWholeResult( function(media_ids) {
			m_mvdetail_open( media_ids, 'detail', idx, null, function() {
				if( done_cb ) done_cb();
			} );
		} );
	}

	function less( done_cb ) {
		mv_offset -= mv_count_fit;
		if( mv_offset < 0 ) mv_offset = 0;
		$('.ctx-menu:visible').parent('div').hide();
		updateSmallView( false, false, null, done_cb );
	}
	function more( done_cb ) {
		mv_offset += mv_count_fit;
		$('.ctx-menu:visible').parent('div').hide();
		updateSmallView( false, false, null, done_cb );
	}


	function download() {
		actionOnWholeResult( function(media_ids) {
			MVDownload.open( media_ids );
		} );
	}
	function send() {
		MVSend.openIndexLists( getLists(), cur_list_id );
	}
	function publish() {
		actionOnWholeResult( function(media_ids) {
			MVPublish.open( media_ids, cur_item.title );
		} );
	}
	function do_export() {
		actionOnWholeResult( function(media_ids) {
			MVExport.open( media_ids );
		} );
	}
	function print() {
		actionOnWholeResult( function(media_ids) {
			MVPrint.open( media_ids, cur_item.title );
		} );
	}
	function edit() {
		MTemplates.queryDialogHTML( 'form_lightbox_edit', function() {
			$('#lb-edit-dialog form').off().submit( function() {
				var title = $('#lb-title').val();
				var object_attributes = { 'title':title };
				MDObject.updateObjectProperties('lightbox',cur_list_id,object_attributes,true,null,null,function(j) {
					setTitleCountNote(title,null,null,true);
					$('#lb-edit-dialog').dialog('destroy');
					updateSmallView(true,false);
				} );
				return false;
			} );
			$('#lb-edit-dialog')
				.dialog('destroy').dialog( { width:262, height:150, modal:true, resizable:false, close:function(ev, ui) {
					$(this).dialog('destroy');
				} } ).show()
				.find('#lb-title')
				.val( cur_item.title ).focus();
			return false;
		} );
	}
	function note() {
		MTemplates.queryDialogHTML( 'form_lightbox_edit', function() {
			$('#lb-note').off().keydown(function(e) {
				if( e.which==13 && (e.ctrlKey || e.metaKey || e.shiftKey) ) {
					// shift/ctrl/alt + ENTER = Save
					e.preventDefault();
					e.stopPropagation();
					$('#lb-note-dialog form').submit();
				}
			});
			$('#lb-note-dialog form').off().submit( function() {
				var note = $('#lb-note').val();
				var object_attributes = { 'note':note };
				MDObject.updateObjectProperties('lightbox',cur_list_id,object_attributes,true,null,null,function(j) {
					setTitleCountNote(null,null,note,true);
					$('#lb-note-dialog').dialog('destroy');
					updateSmallView(true,false);
				} );
				return false;
			});
			$('#lb-note-dialog')
				.dialog('destroy').dialog({width:550, height:330, modal:true, resizable:true, close:function(ev, ui) {
					$(this).dialog('destroy');
				} }).show()
				.find('#lb-note').val(cur_item.note).focus();
			return false;
		});
	}

	function share() {
		// MDObject.queryObjectRelationsOLD( 'lightbox', cur_list_id, 'shared', function( j ) {
		// 	MTemplates.queryDialogHTML('form_lightbox_edit', function() {
		// 		$('#lb-share-dialog').dialog('destroy').dialog({width:550, height:330, modal:true, resizable:true, close:function(ev, ui) {
		// 			$(this).dialog('destroy');
		// 		} }).show();
		// 		$('#share-user-list').empty();
		// 		var available_options = MDObject.getAvailableObjectRelationOptions('lightbox','shared');

		// 		for( var i=0; i<j.user_ids.length; ++i ) {
		// 			var user_id = j.user_ids[i];
		// 			if( user_id==mj.user_id ) continue;

		// 			var user = j.users[user_id];

		// 			$('#share-user-list-item-template').clone(false)
		// 				.attr({
		// 					'id': 'share-user-list-item-'+user_id,
		// 					'list_id': user_id
		// 				})
		// 				.find('input.share-user-list-item-cb')
		// 				.attr({
		// 					'id': 'share-user-list-item-cb-'+user_id,
		// 					'value': user_id
		// 				})
		// 				.prop('checked',user.relation)
		// 				.end()
		// 				.find('label')
		// 				.attr('for','share-user-list-item-cb-'+user_id)
		// 				.find('.lb-user').text(user['display-name']).end()
		// 				.find('.lb-login').text(user.login).end()
		// 				.end()
		// 				.appendTo('#share-user-list')
		// 				.show();

		// 			for( var ii=0; ii<available_options.length; ++ii ) {
		// 				$('#share-user-options-list-item-template').clone(false)
		// 					.attr({
		// 						'id': 'share-user-list-item-'+user_id+'-option-'+available_options[ii],
		// 						'list_id': user_id
		// 					})
		// 					.find('input.share-user-options-list-item-cb')
		// 					.attr({
		// 						'id': 'share-user-list-item-cb-'+user_id+'-option-'+available_options[ii],
		// 						'value': available_options[ii]
		// 					})
		// 					.prop('checked',arr_inArray(available_options[ii],user.relation_options)!==-1)
		// 					.end()
		// 					.find('label')
		// 					.attr('for','share-user-list-item-cb-'+user_id+'-option-'+available_options[ii])
		// 					.find('.lb-option').text(available_options[ii]).end()
		// 					.end()
		// 					.appendTo('#share-user-list-item-'+user_id+' > .options-list')
		// 					.show();
		// 			}
		// 		}
		// 		$('#share-submit').click( function() {
		// 			var relation_items = {};
		// 			$('#share-user-list input.share-user-list-item-cb').filter(':checked').each( function() {
		// 				var user_id = $(this).val();
		// 				var options = [];
		// 				$('#share-user-list-item-'+user_id+' input.share-user-options-list-item-cb').filter(':checked').each( function() {
		// 					options.push($(this).val());
		// 				});
		// 				relation_items[user_id] = options;
		// 			} );
		// 			MDObject.updateObjectRelations(cur_list_id, 'shared', relation_items, function() {
		// 				$('#lb-share-dialog').dialog('close');
		// 			});
		// 		});
		// 	});

		// });
	}

	function del() {
		if( m_single_lb ) return;
		if( cur_list_id==0 ) return;
		confirm_box( mjt('lb-confirm-delete-title'), mjt('lb-confirm-delete'), function() {
			MDObject.deleteObject('lightbox', cur_list_id, function(j) {
				m_select_elem.find('[value='+cur_list_id+']').remove();

				// const wrappedSource = m_result_view_widget.getSource().getWrappedSource();
				// if( wrappedSource.getListType()==='lightbox' && wrappedSource.getObjectId()==cur_list_id ) {
				// 	// result_view was showing contents of this lightbox ...
				// 	// -> reset view
				// 	// m_result_view_widget.loadEmpty();
				// 	MVSearch.loadCurrentSearchResultIntoResultView();
				// }

				if( m_select_elem.find('option').length===1 ) {
					// create new default lightbox
					var title = mjt('lb-default-name');
					var object_attributes = { 'title':title, 'note':'' };
					MDObject.createObject('lightbox',object_attributes,null,false,function(j) {
						renderSelect(j.lists,j.object_id);
						change(j.object_id,true,true);
					} );
				} else {
					// select first
					const firstOptionValue = parseInt( m_select_elem.find('option').first().attr('value'), 10 );
					reRenderSelect(firstOptionValue);
					// const firstOptionValue = parseInt( m_select_elem.find('option').first().attr('value'), 10 );
					// change(firstOptionValue,true,true);
					change(firstOptionValue,true,true,null,null,false,false,true);
				}

			} );
		} );
	}

	function insert( media_ids, pos, ignore_errors ) {
		if( typeof pos === 'undefined' ) pos = -1;
		var pre_count = cur_item.count;
		var item_list = [];
		media_ids.forEach(function(media_id) {
			item_list.push({'media_id': String(media_id)});
		});
		MDObject.insertObjectItems('lightbox', cur_list_id, item_list, pos, function(j) {
			setTitleCountNote(null,j.count,null,true);
			updateSmallView(false,pos==0);
			if( j.count > pre_count ) {
				if( j.count - pre_count == 1 ) showInfoToast( mjt('lb-added-media-1') );
				else showInfoToast( media_ids.length==1 ? mjt('lb-added-media-1') : mjt('lb-added-media').replace('%d',j.count-pre_count) );
			} else if( !ignore_errors ) {
				showWarningToast( media_ids.length==1 ? mjt('lb-added-media-failed-1') : mjt('lb-added-media-failed') );
			}
			if( !mv_open ) selectionChanged(null,'insert -> MDObject.insertObjectItems...');
		} );
	}

	function remove( media_ids, done_cb ) {
		var pre_count = cur_item.count;
		MDObject.removeObjectItems('lightbox', cur_list_id, media_ids, null, function(j) {
			setTitleCountNote(null,j.count,null,true);
			updateSmallView(false,false,null,done_cb);
			if( j.count < pre_count ) {
				if( pre_count - j.count == 1 ) showInfoToast( mjt('lb-removed-media-1') );
				else showInfoToast( mjt('lb-removed-media').replace('%d',pre_count-j.count) );
			} else {
				showWarningToast( mjt('lb-removed-media-failed') );
			}
			if( !mv_open ) selectionChanged(null,'remove -> MDObject.removeObjectItems...');
		}, true );
	}

	function insertIntoOther( media_ids, pos, ignore_errors ) {
		MTemplates.queryDialogHTML( 'form_lightbox_edit', function() {
			var insertItemsIntoLightbox = function( lightbox_id ) {
				m_last_selected_other_lightbox_id = lightbox_id;
				change(lightbox_id,true,true,function() {
					insert(media_ids,pos,ignore_errors);
					$('#lb-select-dialog').dialog('destroy');
					if( !mv_open ) toggleSmallView();
				});
			};
			$('#lb-select-form').off().submit( function() {
				var lightbox_id = $('#lb-select-lightbox-1').mjWidget('get');
				insertItemsIntoLightbox(lightbox_id);
				return false;
			} );
			$('#lb-select-create-form').off().submit( function() {
				var title = str_trim( $('#lb-select-create-title').val() );
				var object_attributes = { 'title':title, 'note':'' };
				MDObject.createObject('lightbox',object_attributes,null,false,function(j) {
					renderSelect(j.lists,j.object_id);
					insertItemsIntoLightbox(j.object_id);
				});
				return false;
			} );
			$('#lb-select-dialog')
				.dialog('destroy')
				.dialog( {
					width: 272,
					height: 350,
					modal: true,
					resizable: false,
					close: function( ev, ui ) {
						$(this).dialog('destroy');
					},
					open: function( ev, ui ) {
						var all_lists = getLists();
						var select_values = [];
						for( var i=0; i<all_lists.length; ++i ) {
							var list_item = all_lists[i];
							if( list_item.owner_id!=mj.user_id ) continue; // skip non-owned lightboxes
							if( list_item.x_name ) continue; // skip lightboxes with plugin attached
							select_values.push([ list_item.list_id, list_item.title ]);
						}
						if( select_values.length===0 || !isValidLightboxId(m_last_selected_other_lightbox_id) ) m_last_selected_other_lightbox_id = null;
						$('#lb-select-form-apply').prop('disabled',select_values.length===0);
						$('#lb-select-lightbox-1')
							.empty()
							.mjWidget( {
								id: 'lb-select-lightbox',
								type: 'list',
								values: select_values,
								width: '100%',
								value: m_last_selected_other_lightbox_id,
								change: function() {
									setTimeout( function() {
										$('#lb-select-form-apply').focus();
									}, 120 );
								},
							} );
						$('#lb-select-create-title')
							.val('')
							.on('change keyup onpaste',function() {
								var str = str_trim($(this).val());
								var valid = str.length>0;
								$('#lb-select-create-form-save').prop('disabled',!valid);
							})
							.trigger('change');
						window.setTimeout( function() {
							$('#lb-select-lightbox-1').mjWidget('focus');
							$('#lb-select-create-title').val( mjt('lb-default-name') ).trigger('change').select();
						}, 12 );
					},
				} )
				.show();
			return false;
		} );
	}


	function activateDropTargets( activate, evt, ui ) {
		$('#media-header-lightbox-1').toggleClass( 'drop-active', activate && !mv_open );
		$('#media-lightbox-small').toggleClass( 'drop-active', activate );
	}

	function selectionChanged( evt, calledFrom ) {
		if( m_selection_changed ) {
			m_selection_changed( evt, cur_item.count <= 1 ? null : openWholeResultInDetailView, (calledFrom??'')+' -> Lightbox::selectionChanged' );
		}
	}

	function getVisibleNodeByMediaId( media_id ) {
		var node = $('#lb-result > .lb-item[data-mj_mid='+media_id+']');
		return node.length ? node : null;
	}

	function selectVisibleNodes( media_ids, replace_selection ) {
		var candidate_nodes = $('#lb-result > .lb-item');
		if( replace_selection ) {
			candidate_nodes.filter('.ui-selected').removeClass('ui-selected');
		}
		_withNodesByMediaIds( media_ids, function( media_id, node ) {
			node.addClass('ui-selected');
		} );
		this.selectionChanged(null,'selectVisibleNodes');
	}

	function _withNodeByMediaId( media_id, cb ) {
		var node = $('#lb-result > .lb-item[data-mj_mid='+media_id+']');
		if( node.length ) cb(media_id,node);
	}

	function _withNodesByMediaIds( media_ids, cb ) {
		var lb_items = $('#lb-result > .lb-item');
		$.each( media_ids, function( idx, media_id ) {
			var node = lb_items.filter('[data-mj_mid='+media_id+']');
			if( node.length ) cb(media_id,node);
		});
	}

	function getItemDimensions( lb_item ) {
		var p = lb_item.offset();
		var pos = {
			top:	Math.floor(p.top+1.5),
			left:	Math.floor(p.left+1.5),
		};
		pos.bottom = pos.top  + lb_item.outerHeight() - 4;
		pos.right  = pos.left + lb_item.outerWidth()  - 4;
		return pos;
	}

	function isEnabled() {
		return m_lightbox_enabled;
	}
	function isEditable() {
		return cur_list_id!=0 && !isLocked();
	}

	function triggerLightboxChanged( list_id, list_item ) {
		for( var i=0; i<m_changed_cbs.length; ++i ) {
			m_changed_cbs[i](list_id,list_item,isEditable());
		}
	}

	// function bindLightboxChanged( cb ) {
	// 	m_changed_cbs.push(cb);
	// }


	return {

		initDisabled,
		init,

		updateSmallView,
		change,
		update,

		updateActionViewStates,
		setLocked,
		isLocked,

		openWholeResultInDetailView,
		isValidLightboxId,
		go,
		open,
		less,
		more,

		insert,
		remove,
		insertIntoOther,

		activateDropTargets,
		selectionChanged,

		getVisibleNodeByMediaId,
		selectVisibleNodes,

		getItemDimensions,

		isEnabled,
		isEditable,
		// bindLightboxChanged,

	};
}(jQuery,mj); // namespace Lightbox
